// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* VARIABLES */
:root {
  --text: #05100f;
  --background: #e8f8f7;
  --background-100: #d8f3f1;
  --background-200: #b1e7e3;
  --background-300: #8adbd6;
  --background-400: #63cfc8;
  --background-500: #3cc3ba;
  --primary: #306a9c;
  --secondary: #b9bae9;
  --secondaryHover: #8b8cda;
  --accent: #3236a4;
  --highPriority: #d00000;
  --mediumPriority: #eeba0b;
  --lowPriority: #008000;
  --nonePriority: #495057;
}

/* RESET */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* GLOBAL STYLES */
html {
  font-size: 10px;
}

body,
html {
  height: 100%;
  min-height: 100vh;
}

body {
  font-size: 1.6rem;
}

button {
  cursor: pointer;
  border: none;
  background: none;
  outline: none;
  padding: 4px 8px;
  border-radius: 4px;
  font-family: inherit;
}

button:hover {
  cursor: pointer;
  background-color: var(--secondaryHover);
}

.icon {
  width: 2.8rem;
  height: 2.8rem;
}

/* LAYOUT */
#container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  font-family: "poppins", sans-serif;
}

/* SIDEBAR */
.sidebar {
  background-color: var(--secondary);
  color: var(--text);
  width: 20%;
  height: 100%;
  padding: 1.2rem;
  font-family: "poppins", sans-serif;
  position: sticky;
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.sidebar-header button.profile {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 2rem;
}

.sidebar-header button.profile img {
  width: 3rem;
  height: 3rem;
}

.top-sidebar-btns {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

.top-sidebar-btns button {
  display: flex;
}

.tasks-menu {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
}

.tasks-menu button {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  font-size: 1.8rem;
}

.tasks-menu .tasks-header {
  display: flex;
  justify-content: space-between;
  font-size: 1.6rem;
}

.tasks-menu .tasks-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tasks-menu .task-item {
  display: flex;
  justify-content: space-between;
}

.tasks-menu .task-item.active {
  background-color: var(--secondaryHover);
}

.tasks-menu .task-item-left {
  display: flex;
  flex-grow: 1;
  gap: 12px;
}

.task-item .todo-length {
  font-size: 1.4rem;
}

.projects-menu {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.projects-menu button {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  font-size: 1.8rem;
  text-transform: capitalize;
}

.projects-menu .projects-header {
  display: flex;
  justify-content: space-between;
  font-size: 1.6rem;
}

.projects-menu .projects-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: auto;
  height: 300px;
  /* height: 100%; */
}

.projects-menu .project-item {
  display: flex;
  justify-content: space-between;
}

.projects-menu .project-item.active {
  background-color: var(--secondaryHover);
}

.projects-menu .project-item-left {
  display: flex;
  flex-grow: 1;
  gap: 12px;
}

.project-item .todo-length {
  font-size: 1.4rem;
}

/* TODO CONTAINER */
.todo-container {
  width: 80%;
  height: 100%;
  padding: 4rem 2rem;
  background-color: var(--background);
}

.todo-header {
  display: flex;
  flex-direction: row;
  gap: 0.8rem;
  align-items: baseline;
  justify-content: flex-start;
  margin-bottom: 2rem;
  font-family: "poppins", sans-serif;
  padding-bottom: 1rem;
  border-bottom: 1px solid #000;
  text-transform: capitalize;
  position: sticky;
}

.number-of-todos {
  font-size: 2.4rem;
  background-color: var(--accent);
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.todo-list-container {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  /* height: auto; */
  height: 500px;
  overflow: auto;
}

/* TODO ITEM */
.todo-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 1.6rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  font-family: "poppins", sans-serif;
  transition: all 0.2s;
  gap: 16px;
}

.todo-item.todo-item-checked {
  background-color: #f9f9f9;
}

.todo-item.todo-item-checked:hover {
  background-color: #f9f9f9;
  color: #ccc;
}

.todo-item.todo-item-checked .todo-item-title {
  text-decoration: line-through;
  color: #ccc;
}

.todo-item.todo-item-checked .todo-item-description {
  text-decoration: line-through;
  color: #ccc;
}

.todo-item.todo-item-checked .todo-item-date {
  color: #999;
}

.todo-item.todo-item-checked .todo-item-right :not(.todo-item-date) {
  display: none;
}

.todo-item:hover {
  background-color: var(--secondary);
  color: var(--text);
}

.todo-item button {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 4px;
}

.todo-item-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.todo-item-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.todo-item-title {
  font-size: 2rem;
}

.todo-item-title::first-letter {
  text-transform: uppercase;
}

.todo-item-description {
  font-size: 1.6rem;
  color: #333;
  flex: 1;
}

.todo-item-priority {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  margin: 0.8rem;
}

.lowPriority-todo {
  background-color: var(--lowPriority);
}

.mediumPriority-todo {
  background-color: var(--mediumPriority);
}

.highPriority-todo {
  background-color: var(--highPriority);
}

.nonePriority-todo {
  background-color: var(--nonePriority);
}

.lowPriority-text {
  color: var(--lowPriority);
}

.mediumPriority-text {
  color: var(--mediumPriority);
}

.highPriority-text {
  color: var(--highPriority);
}

.nonePriority-text {
  color: var(--nonePriority);
}

.todo-item-date {
  font-size: 1.6rem;
  margin-right: 3.6rem;
}

/* MODALS */
dialog {
  margin: 150px auto auto;
  border-radius: 4px;
  padding: 16px;
  background-color: var(--background);
  border: 2px solid #999;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 600px;
}

dialog input,
dialog select {
  border: none;
  outline: none;
  font-family: inherit;
  color: (var(--text));
  cursor: pointer;
}

dialog input[type="text"] {
  background-color: transparent;
}

dialog button {
  font-size: 1.6rem;
  padding: 4px 12px;
}

dialog .cancel-btn {
  background-color: #999;
}

dialog .cancel-btn:hover {
  background-color: var(--secondaryHover);
}

dialog .confirm-btn {
  margin-left: 8px;
  color: #fff;
  background-color: var(--accent);
}

dialog .confirm-btn:hover {
  color: var(--text);
  background-color: var(--secondaryHover);
}

.add-or-edit-modal .dialog-top {
  display: flex;
  flex-direction: column;
}

.add-or-edit-modal .dialog-top input {
  background-color: transparent;
}

.add-or-edit-modal input#task-title,
.add-or-edit-modal input#project-title {
  color: (var(--text));
  font-size: 2.8rem;
  font-weight: 800;
}

.add-or-edit-modal input#task-title::placeholder {
  font-size: 2.8rem;
  opacity: 50%;
}

.add-or-edit-modal input#task-description {
  font-size: 1.6rem;
  margin-bottom: 16px;
}

.add-or-edit-modal input#task-description::placeholder {
  font-size: 1.6rem;
  opacity: 50%;
}

.add-or-edit-modal input#due-date {
  font-size: 1.6rem;
  background-color: #999;
  border-radius: 2px;
  padding: 4px;
  margin-right: 16px;
}

.add-or-edit-modal select {
  background-color: #999;
  padding: 4px;
  border-radius: 2px;
  font-size: 1.6rem;
}

.add-or-edit-modal .dialog-middle {
  margin-bottom: 20px;
}

.add-or-edit-modal .dialog-bottom {
  padding-top: 20px;
  border-top: 1px solid #999;
  display: flex;
  justify-content: space-between;
}

.add-or-edit-modal input#project-title {
  color: (var(--text));
  font-size: 2.8rem;
  font-weight: 800;
}

.add-or-edit-modal .dialog-top {
  margin-bottom: 20px;
}

.add-or-edit-modal .dialog-bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.add-or-edit-modal input#project-title::placeholder {
  color: (var(--text));
  font-size: 2.8rem;
  opacity: 50%;
}

#delete-todo-modal h3 {
  font-size: 2.4rem;
  margin-bottom: 4px;
}

#delete-todo-modal .warning {
  font-size: 1.6rem;
  margin-bottom: 20px;
}

#delete-todo-modal .dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

#delete-todo-modal .delete-btn {
  background-color: #d00000;
  color: #fff;
  font-weight: 500;
}

#delete-todo-modal .todo-name {
  font-weight: 700;
  font-size: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;AACpC;;AAEA,YAAY;AACZ;EACE,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,kCAAkC;EAClC,oBAAoB;EACpB,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,kCAAkC;EAClC,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mCAAmC;EACnC,sBAAsB;EACtB,uCAAuC;EACvC,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["/* VARIABLES */\n:root {\n  --text: #05100f;\n  --background: #e8f8f7;\n  --background-100: #d8f3f1;\n  --background-200: #b1e7e3;\n  --background-300: #8adbd6;\n  --background-400: #63cfc8;\n  --background-500: #3cc3ba;\n  --primary: #306a9c;\n  --secondary: #b9bae9;\n  --secondaryHover: #8b8cda;\n  --accent: #3236a4;\n  --highPriority: #d00000;\n  --mediumPriority: #eeba0b;\n  --lowPriority: #008000;\n  --nonePriority: #495057;\n}\n\n/* RESET */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* GLOBAL STYLES */\nhtml {\n  font-size: 10px;\n}\n\nbody,\nhtml {\n  height: 100%;\n  min-height: 100vh;\n}\n\nbody {\n  font-size: 1.6rem;\n}\n\nbutton {\n  cursor: pointer;\n  border: none;\n  background: none;\n  outline: none;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-family: inherit;\n}\n\nbutton:hover {\n  cursor: pointer;\n  background-color: var(--secondaryHover);\n}\n\n.icon {\n  width: 2.8rem;\n  height: 2.8rem;\n}\n\n/* LAYOUT */\n#container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  height: 100%;\n  font-family: \"poppins\", sans-serif;\n}\n\n/* SIDEBAR */\n.sidebar {\n  background-color: var(--secondary);\n  color: var(--text);\n  width: 20%;\n  height: 100%;\n  padding: 1.2rem;\n  font-family: \"poppins\", sans-serif;\n  position: sticky;\n}\n\n.sidebar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.sidebar-header button.profile {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  font-size: 2rem;\n}\n\n.sidebar-header button.profile img {\n  width: 3rem;\n  height: 3rem;\n}\n\n.top-sidebar-btns {\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n}\n\n.top-sidebar-btns button {\n  display: flex;\n}\n\n.tasks-menu {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.tasks-menu button {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 1rem;\n  font-size: 1.8rem;\n}\n\n.tasks-menu .tasks-header {\n  display: flex;\n  justify-content: space-between;\n  font-size: 1.6rem;\n}\n\n.tasks-menu .tasks-container {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.tasks-menu .task-item {\n  display: flex;\n  justify-content: space-between;\n}\n\n.tasks-menu .task-item.active {\n  background-color: var(--secondaryHover);\n}\n\n.tasks-menu .task-item-left {\n  display: flex;\n  flex-grow: 1;\n  gap: 12px;\n}\n\n.task-item .todo-length {\n  font-size: 1.4rem;\n}\n\n.projects-menu {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.projects-menu button {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 1rem;\n  font-size: 1.8rem;\n  text-transform: capitalize;\n}\n\n.projects-menu .projects-header {\n  display: flex;\n  justify-content: space-between;\n  font-size: 1.6rem;\n}\n\n.projects-menu .projects-container {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  overflow: auto;\n  height: 300px;\n  /* height: 100%; */\n}\n\n.projects-menu .project-item {\n  display: flex;\n  justify-content: space-between;\n}\n\n.projects-menu .project-item.active {\n  background-color: var(--secondaryHover);\n}\n\n.projects-menu .project-item-left {\n  display: flex;\n  flex-grow: 1;\n  gap: 12px;\n}\n\n.project-item .todo-length {\n  font-size: 1.4rem;\n}\n\n/* TODO CONTAINER */\n.todo-container {\n  width: 80%;\n  height: 100%;\n  padding: 4rem 2rem;\n  background-color: var(--background);\n}\n\n.todo-header {\n  display: flex;\n  flex-direction: row;\n  gap: 0.8rem;\n  align-items: baseline;\n  justify-content: flex-start;\n  margin-bottom: 2rem;\n  font-family: \"poppins\", sans-serif;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #000;\n  text-transform: capitalize;\n  position: sticky;\n}\n\n.number-of-todos {\n  font-size: 2.4rem;\n  background-color: var(--accent);\n  width: 3.2rem;\n  height: 3.2rem;\n  border-radius: 50%;\n  font-weight: 600;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n}\n\n.todo-list-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1.6rem;\n  /* height: auto; */\n  height: 500px;\n  overflow: auto;\n}\n\n/* TODO ITEM */\n.todo-item {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.8rem 1.6rem;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  font-family: \"poppins\", sans-serif;\n  transition: all 0.2s;\n  gap: 16px;\n}\n\n.todo-item.todo-item-checked {\n  background-color: #f9f9f9;\n}\n\n.todo-item.todo-item-checked:hover {\n  background-color: #f9f9f9;\n  color: #ccc;\n}\n\n.todo-item.todo-item-checked .todo-item-title {\n  text-decoration: line-through;\n  color: #ccc;\n}\n\n.todo-item.todo-item-checked .todo-item-description {\n  text-decoration: line-through;\n  color: #ccc;\n}\n\n.todo-item.todo-item-checked .todo-item-date {\n  color: #999;\n}\n\n.todo-item.todo-item-checked .todo-item-right :not(.todo-item-date) {\n  display: none;\n}\n\n.todo-item:hover {\n  background-color: var(--secondary);\n  color: var(--text);\n}\n\n.todo-item button {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 4px;\n}\n\n.todo-item-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.todo-item-right {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.todo-item-title {\n  font-size: 2rem;\n}\n\n.todo-item-title::first-letter {\n  text-transform: uppercase;\n}\n\n.todo-item-description {\n  font-size: 1.6rem;\n  color: #333;\n  flex: 1;\n}\n\n.todo-item-priority {\n  width: 2rem;\n  height: 2rem;\n  border-radius: 50%;\n  margin: 0.8rem;\n}\n\n.lowPriority-todo {\n  background-color: var(--lowPriority);\n}\n\n.mediumPriority-todo {\n  background-color: var(--mediumPriority);\n}\n\n.highPriority-todo {\n  background-color: var(--highPriority);\n}\n\n.nonePriority-todo {\n  background-color: var(--nonePriority);\n}\n\n.lowPriority-text {\n  color: var(--lowPriority);\n}\n\n.mediumPriority-text {\n  color: var(--mediumPriority);\n}\n\n.highPriority-text {\n  color: var(--highPriority);\n}\n\n.nonePriority-text {\n  color: var(--nonePriority);\n}\n\n.todo-item-date {\n  font-size: 1.6rem;\n  margin-right: 3.6rem;\n}\n\n/* MODALS */\ndialog {\n  margin: 150px auto auto;\n  border-radius: 4px;\n  padding: 16px;\n  background-color: var(--background);\n  border: 2px solid #999;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  width: 600px;\n}\n\ndialog input,\ndialog select {\n  border: none;\n  outline: none;\n  font-family: inherit;\n  color: (var(--text));\n  cursor: pointer;\n}\n\ndialog input[type=\"text\"] {\n  background-color: transparent;\n}\n\ndialog button {\n  font-size: 1.6rem;\n  padding: 4px 12px;\n}\n\ndialog .cancel-btn {\n  background-color: #999;\n}\n\ndialog .cancel-btn:hover {\n  background-color: var(--secondaryHover);\n}\n\ndialog .confirm-btn {\n  margin-left: 8px;\n  color: #fff;\n  background-color: var(--accent);\n}\n\ndialog .confirm-btn:hover {\n  color: var(--text);\n  background-color: var(--secondaryHover);\n}\n\n.add-or-edit-modal .dialog-top {\n  display: flex;\n  flex-direction: column;\n}\n\n.add-or-edit-modal .dialog-top input {\n  background-color: transparent;\n}\n\n.add-or-edit-modal input#task-title,\n.add-or-edit-modal input#project-title {\n  color: (var(--text));\n  font-size: 2.8rem;\n  font-weight: 800;\n}\n\n.add-or-edit-modal input#task-title::placeholder {\n  font-size: 2.8rem;\n  opacity: 50%;\n}\n\n.add-or-edit-modal input#task-description {\n  font-size: 1.6rem;\n  margin-bottom: 16px;\n}\n\n.add-or-edit-modal input#task-description::placeholder {\n  font-size: 1.6rem;\n  opacity: 50%;\n}\n\n.add-or-edit-modal input#due-date {\n  font-size: 1.6rem;\n  background-color: #999;\n  border-radius: 2px;\n  padding: 4px;\n  margin-right: 16px;\n}\n\n.add-or-edit-modal select {\n  background-color: #999;\n  padding: 4px;\n  border-radius: 2px;\n  font-size: 1.6rem;\n}\n\n.add-or-edit-modal .dialog-middle {\n  margin-bottom: 20px;\n}\n\n.add-or-edit-modal .dialog-bottom {\n  padding-top: 20px;\n  border-top: 1px solid #999;\n  display: flex;\n  justify-content: space-between;\n}\n\n.add-or-edit-modal input#project-title {\n  color: (var(--text));\n  font-size: 2.8rem;\n  font-weight: 800;\n}\n\n.add-or-edit-modal .dialog-top {\n  margin-bottom: 20px;\n}\n\n.add-or-edit-modal .dialog-bottom {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.add-or-edit-modal input#project-title::placeholder {\n  color: (var(--text));\n  font-size: 2.8rem;\n  opacity: 50%;\n}\n\n#delete-todo-modal h3 {\n  font-size: 2.4rem;\n  margin-bottom: 4px;\n}\n\n#delete-todo-modal .warning {\n  font-size: 1.6rem;\n  margin-bottom: 20px;\n}\n\n#delete-todo-modal .dialog-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n#delete-todo-modal .delete-btn {\n  background-color: #d00000;\n  color: #fff;\n  font-weight: 500;\n}\n\n#delete-todo-modal .todo-name {\n  font-weight: 700;\n  font-size: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
